import { regionsStore } from '../stores';

// Словарь соответствий group_id -> название группы (единый для всего UI)
// Используется как fallback, если данные из RegionsStore недоступны
export const groupIdToTitle = {
  "-80315714": "Администрация г. Снежинска",
  "-32444926": "Говорит Саров",
  "-80950633": "Говорит СНЕЖИНСК (Метрополия Снежинск)",
  "-59472296": "Говорят в Снежинске",
  "-35911547": "Затоновости Саров",
  "-48632629": "ИКТИБ ЮФУ",
  "-252491": "МЫ ИЗ САРОВА | НОВОСТИ САРОВ",
  "-61784388": "Новая таганрогская по ссылке",
  "-210246593": "Нововоронеж 24",
  "-140223588": "ПОДСЛУШАНО В СНЕЖИНСКЕ",
  "-59848442": "Подслушано Нововоронеж",
  "-62818821": "Подслушано САРОВ",
  "-152253978": "Подслушано Снежинск",
  "-818023": "Саров",
  "-101957040": "СИЦ ААИ",
  "-130544609": "Снежинск",
  "-203781938": "Снежинский Сплетник",
  "-148944189": "Снежинск.СОБЫТИЯ",
  "-891791717": "Таганрог",
  "-100105861": "Услышано в Снежинске"
};

export const getGroupTitleById = (groupId) => {
  const idStr = String(groupId);
  
  // Сначала пытаемся получить данные из RegionsStore
  const group = regionsStore.getGroupById(groupId);
  if (group) {
    return group.title;
  }
  
  // Fallback на статический словарь
  return groupIdToTitle[idStr] || idStr;
};


